import dayTradeReport from './dayTradeReport';
import positionReport from './positionReport';
import bBookReport from './bBookReport';
import clientReport from './clientReport';
import monitorAccounts from './monitorAccountsReport';
import autoPositionReport from './autoPositionReport';
import autoUpdateLeverage from './autoUpdateLeverage';
import chargeDividends from './chargeDividends';

const reportLanguages = [
    dayTradeReport,
    positionReport,
    bBookReport,
    clientReport,
    monitorAccounts,
    autoPositionReport,
    autoUpdateLeverage,
    chargeDividends,
]

export default reportLanguages;


// WEBPACK FOOTER //
// ./src/language/report/index.js